export { default, type StaticToastProps } from './StaticToast';
